import React, { useEffect, useState } from "react";
import moment from "moment";
export default function Clock({ ...props }) {
  const [time, setTime] = useState(moment());

  useEffect(() => {
    setInterval(() => {
      setTime(moment());
    }, 1000);
  }, []);

  return (
    <p style={{ textAlign: "right", color: "white", fontSize: 14 }}>
      {`${time.format("LL")} ${time.format("LTS")}`}
    </p>
  );
}
